import { RootState } from "app.store";
import * as React from "react";
import { useSelector } from "react-redux";
import "./loading.less";
import clsx from 'clsx';
export function Loading(props: any) {
  const isLoading = useSelector(
    (state: RootState) => state.globalValue.isLoading
  );
  return (
    <div className={clsx(isLoading && `Backdrop`)}>
      <div className={`Loader`}>{props.children}</div>
    </div>
  );
}
